import { SET_ID_CRM_ACTION } from "./reducersConstants";

export const setIdCrmAction = (data) => {
  return {
    type: SET_ID_CRM_ACTION,
    data,
  };
};

export const idCrmReducer = (previousState = "", { type, data }) => {
  switch (type) {
    case SET_ID_CRM_ACTION:
      return data;
    default:
      return previousState;
  }
};
